import { render, staticRenderFns } from "./PAPI.vue?vue&type=template&id=31a4dc75&"
import script from "./PAPI.vue?vue&type=script&lang=js&"
export * from "./PAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports